import { useEffect } from 'react';
import { useRouteError, isRouteErrorResponse, useNavigate, useLocation } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
function ErrorBoundary() {
    const error = useRouteError();
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => { if (isRouteErrorResponse(error)) {
        if (error.status === 401) {
            const redirectTo = location.pathname + location.search;
            navigate(`/login?redirectTo=${redirectTo}`);
        }
    } }, [error]);
    if (isRouteErrorResponse(error)) {
        switch (error.status) {
            case 404:
            case 400: return /*#__PURE__*/ _jsx("div", { children: "400" }); // break;
            case 503: return /*#__PURE__*/ _jsx("div", { children: "503" });
            case 418: return /*#__PURE__*/ _jsx("div", { children: "418" });
            default: return /*#__PURE__*/ _jsx("div", { children: "some error" });
        }
    }
    throw error;
}
export default ErrorBoundary;
